export type LogoTickerItem = {
  src: string;
  alt: string;
  width: number;
  height: number;
};

export const LOGO_TICKER_ITEMS: LogoTickerItem[] = [
  { src: "/logos/apb-v2.png", alt: "APB", width: 326, height: 176 },
  { src: "/logos/erona-app.png", alt: "Erona", width: 630, height: 176 },
  { src: "/logos/esi-patrimoine-logo.png", alt: "ESI Patrimoine", width: 452, height: 176 },
  { src: "/logos/jwl-marketing.png", alt: "JWL Marketing", width: 329, height: 176 },
  { src: "/logos/rizzclub.png", alt: "Rizz Club", width: 754, height: 176 },
  { src: "/logos/signatures-france-vf.png", alt: "Signatures France", width: 695, height: 176 },
  { src: "/logos/star-limousine.png", alt: "Star Limousine Paris", width: 314, height: 176 },
  {
    src: "/logos/logo_verdi_events 1 1 (1).png",
    alt: "Verdi Events",
    width: 458,
    height: 176,
  },
];
